import api from '@core/api/';
import { set, toggle } from '@core/store/utils';

const state = {
  isLoading: false,
  beneficiariesFilter: null,
  data: [],
};

const getters = {
  isLoading: state => state.isLoading,
  beneficiaries: (state, getters, rootState) => (state.data && state.data.length > 0) ? state.data.map((o) => {
    let label = o.company_name || '';
    const country = rootState.guarantee.countries.list.find(item => item.id === o.country_id);
    const parts = [o.street, o.zip_code, o.city, country && country.label].filter(Boolean);

    if (parts.length) {
      label += ', ' + parts.join(', ');
    }

    return {
      label: label,
      value: o.company_name,
      id: o.id
    };
  }) : [],
  activeBeneficiary: state => (id) => state.data.find(o => o.id === id) || {},
};

const actions = {
  /**
   * send query to API
   * @method sendQuery
   */
  sendQuery({ commit, state, rootState }, searchQuery) {
    if (searchQuery.length < 3) return;

    commit('toggleLoading');

    const query = {
      params: { company_name: searchQuery }
    };

    api.getApiData('accounts/' + rootState.user.user.account.id + '/beneficiaries', query).then(({ data: responseData }) => {
      const beneficiaries = responseData.data;

      if (responseData.data.length) {
        if (state.beneficiariesFilter) {
          let i = beneficiaries.length;
          while (i--) {
            if (Object.values(state.beneficiariesFilter).indexOf('' + beneficiaries[i].id) < 0) { //needs casting to string because 'keys' returns array of strings
              beneficiaries.splice(i, 1);
            }
          }
        }
      }

      commit('setData', beneficiaries);
      commit('toggleLoading');
    }).catch((error) => {
      api.apiError(error);
      commit('toggleLoading');
    });
  }
};

const mutations = {
  setData: set('data'),
  setBeneficiariesFilter: set('beneficiariesFilter'),
  toggleLoading: toggle('isLoading'),
  clear: state => state.data = []
};

export default {
  namespaced: true,

  state,
  getters,
  actions,
  mutations
};
